<script context="module">
  import { writable } from 'svelte/store'

  export const TAB = {
    INFO: 'info',
    CHANGE: 'change',
    ORDERS: 'orders',
  }

  export const tab = writable(TAB.INFO)
</script>

<script>
  import { createEventDispatcher } from 'svelte'

  export let isDuckCreekSource
  export let hasEnthusiastFeature

  const dispatch = createEventDispatcher()

  function handleTabClick(selected) {
    tab.set(selected)
    dispatch('click')
  }

  const tabs = isDuckCreekSource && hasEnthusiastFeature
    ? [[TAB.INFO, 'HDC Info']]
    : [
        [TAB.INFO, 'HDC Info'],
        [TAB.CHANGE, 'Change'],
        [TAB.ORDERS, 'Orders'],
      ]
</script>

<div>
  {#each tabs as t}
    <span class:active={$tab === t[0]} data-cy={`tab-${t[0]}`} on:click={() => handleTabClick(t[0])}>{t[1]}</span>
  {/each}
</div>

<style>
  div {
    border-bottom: 1px solid #dee0e2;
    font-size: 16px;
    display: flex;
  }
  span {
    cursor: pointer;
    padding: 8px 0;
    text-align: center;
    flex: 1;
    color: #8e949a;
  }
  .active {
    border-bottom: 2px solid #007bb3;
    color: black;
  }
</style>
